import React from 'react'
import "./Header.css"
import {Link} from "react-router-dom"
import { ShoppingCart    } from "phosphor-react";
import {useDispatch, useSelector} from "react-redux" 
import {auth} from "../firebase"
import {setUser} from "../redux/userSlice"
import {MagnifyingGlass} from "phosphor-react"

function Header() {
  const basketLength = useSelector(state => state.cart.basket.length)
  const user = useSelector(state => state.user.user)
  
  const linkStyle = {textDecoration: 'none', color: 'white'}
  const dispatch = useDispatch()

  function authenticationHandler(){
    if(user){
      auth.signOut()
      dispatch(setUser(null))
      
    }

  }
  return (
      <div className='header'>
        <Link to="/">
          <img className="header-logo" src="http://pngimg.com/uploads/amazon/amazon_PNG11.png" />
        </Link>
        <div className='search-container'>
          <input className='search-bar'></input>
          <div className='search-icon'>
            <MagnifyingGlass size={23}/>
          </div>
        </div>
        <div className='nav-bar'>
        <Link to={!user ? "/login" : "#"} style={linkStyle}>
          <div className='nav-bar-item' onClick={authenticationHandler}>
            <div className='nav-bar-item-top'>Hello {user? ((user.slice(0,user.indexOf("@"))[0]).toUpperCase() + user.slice(1,user.indexOf("@"))): "Guest"}</div>
            <div className='nav-bar-item-bottom'>Sign {user? "Out":"In"}</div>
          </div>
        </Link>
        <Link to="/orders" style={linkStyle}>
          <div className='nav-bar-item'>
            <div className='nav-bar-item-top'>Returns</div>
            <div className='nav-bar-item-bottom'> & Orders</div>
          </div>
          </Link>
          <Link to="/error" style={linkStyle}>
            <div className='nav-bar-item'>
              <div className='nav-bar-item-top'>Your</div>
              <div className='nav-bar-item-bottom'>Prime</div>
            </div>
          </Link>

          
          <Link to="/checkout" style={linkStyle}>
            <div className='nav-bar-item'>
              <div className='nav-bar-basket'>
                <ShoppingCart   size={25} className='nav-bar-basket-icon'/>
                <span className='nav-bar-basket-count'>{basketLength}</span>
              </div>
            </div>
          </Link>

        </div>

      </div>
  )
}

export default Header